import { FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";

export const social = [
  {
    url: "https://facebook.com/Techsa-110788137918970/",
    name: "Facebook",
    icon: <FaFacebook />,
  },
  {
    url: "https://www.instagram.com/techsabrasil/",
    name: "Instagram",
    icon: <FaInstagram />,
  },
  {
    url: "https://twitter.com/techsabrasil",
    name: "Twitter",
    icon: <FaTwitter />,
  },
];
